var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_37643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66666H8V5.33333H16V2.66666Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 5.33334H16V8H18.6667V5.33334Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 8H18.6667V16H21.3333V8Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 16H16V18.6667H18.6667V16Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6667H8V21.3333H16V18.6667Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 16H5.33334V18.6667H8.00001V16Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33332 8H2.66666V16H5.33332V8Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 5.33334H5.33334V8H8.00001V5.33334Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 18.6667H18.6667V21.3333H21.3333V18.6667Z",
    fill: "#E6D7C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21.3333H21.3333V24H24V21.3333Z",
    fill: "#E6D7C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_37643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.435adfdfa1baf5ea2a4d6e64ad5e3a9a.svg";
export { ForwardRef as ReactComponent };